import { ReactNode, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import "../../amazon-ads.scss";
import HelperService from "../../../../Services/HelperService";
import { Skeleton } from "../../../Common/Skeleton/Skeleton";

// While loading, a value becomes a bar at the value's line height; its label stays.
const MetricValue = (props: { loading?: boolean; children: ReactNode }) => (
  <div className="font-18 font-bold">
    {props.loading ? (
      <Skeleton width="60%" height={20} style={{ margin: "3px auto 4px" }} />
    ) : (
      props.children
    )}
  </div>
);

const OverviewCards = (props: { overview: any; loading?: boolean }) => {
  useEffect(() => {}, []);
  return (
    <div>
      <Card className="overview-card">
        <Row className="">
          <Col>
            <div className="cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">ACOS</div>
                <MetricValue loading={props.loading}>
                  {props.overview.ACOS
                    ? HelperService.numberWithCommas(props.overview.ACOS)
                    : 0}
                  %
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">ROAS</div>
                <MetricValue loading={props.loading}>
                  {props?.overview?.ROAS
                    ? HelperService.numberWithCommas(props?.overview?.ROAS)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Spend
                </div>
                <MetricValue loading={props.loading}>
                  <span className="font-18 font-bold">$</span>
                  {props.overview.spend
                    ? HelperService.numberWithCommas(props.overview.spend)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Sales
                </div>
                <MetricValue loading={props.loading}>
                  <span className="font-18 font-bold">$</span>
                  {props.overview.sales
                    ? HelperService.numberWithCommas(props.overview.sales)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Clicks
                </div>
                <MetricValue loading={props.loading}>
                  {" "}
                  {props.overview.clicks
                    ? HelperService.numberWithCommas(props.overview.clicks)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Impression
                </div>
                <MetricValue loading={props.loading}>
                  {" "}
                  {props.overview.impressions
                    ? HelperService.numberWithCommas(props.overview.impressions)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
          <Col>
            <div className="cursor-pointer text-center ">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Orders
                </div>
                <MetricValue loading={props.loading}>
                  {" "}
                  {props.overview.purchases
                    ? HelperService.numberWithCommas(props.overview.purchases)
                    : 0}
                </MetricValue>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default OverviewCards;
